import type { IpdbState, IpdbStore } from "./ipdbStore";

// NOTE: `selectIpdbState` returns a new object literal every call and MUST be
// consumed with `useShallow`:
//   import { useShallow } from "zustand/react/shallow";
//   useIpdbStore(useShallow(selectIpdbState))

// ── Scalar selectors ─────────────────────────────────────────────────────────
export const selectShowIpdb = (s: IpdbStore) => s.showIpdb;
export const selectLegendItems = (s: IpdbStore) => s.legendItems;
export const selectLegendTitle = (s: IpdbStore) => s.legendTitle;

export const selectModelSource = (s: IpdbStore) => s.modelSource;
export const selectSelectedIpdbFieldData = (s: IpdbStore) => s.selectedIpdbFieldData;
export const selectSelectedZoneKeys = (s: IpdbStore) => s.selectedZoneKeys;
export const selectSelectedIpdbZones = (s: IpdbStore) => s.selectedIpdbZones;
export const selectIpdbZoneInCalculation = (s: IpdbStore) => s.ipdbZoneInCalculation;
export const selectSearchValue = (s: IpdbStore) => s.searchValue;
export const selectTreeData = (s: IpdbStore) => s.treeData;
export const selectOrgLayerKeyToName = (s: IpdbStore) => s.orgLayerKeyToName;
export const selectOrgLayerKeyToGroup = (s: IpdbStore) => s.orgLayerKeyToGroup;
export const selectExpandedKeys = (s: IpdbStore) => s.expandedKeys;
export const selectUseNativeSource = (s: IpdbStore) => s.useNativeSource;
export const selectAllFieldsDataForSelectedZones = (s: IpdbStore) =>
  s.allFieldsDataForSelectedZones;

export const selectIsBinUsingDefaultValues = (s: IpdbStore) => s.isBinUsingDefaultValues;

export const selectIpdbColorPaletteName = (s: IpdbStore) => s.ipdbColorPaletteName;
export const selectReverseColor = (s: IpdbStore) => s.reverseColor;
export const selectInterpolateColors = (s: IpdbStore) => s.interpolateColors;
export const selectShowControlWells = (s: IpdbStore) => s.showControlWells;
export const selectShowZero = (s: IpdbStore) => s.showZero;

export const selectBinErrorMsg = (s: IpdbStore) => s.binErrorMsg;
export const selectDataErrorMsg = (s: IpdbStore) => s.dataErrorMsg;
export const selectColorErrorMsg = (s: IpdbStore) => s.colorErrorMsg;

export const selectIsLoading = (s: IpdbStore) => s.isLoading;

// ── Action selectors ─────────────────────────────────────────────────────────
export const selectUpdate = (s: IpdbStore) => s.update;
export const selectReset = (s: IpdbStore) => s.reset;

// ── Compound selectors ───────────────────────────────────────────────────────

/**
 * Full flat IPDB state object (actions stripped). Returns a new object on
 * every call — consumers MUST use shallow equality:
 *
 *   import { useShallow } from "zustand/react/shallow";
 *   const state = useIpdbStore(useShallow(selectIpdbState));
 */
export const selectIpdbState = (s: IpdbStore): IpdbState => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { update, reset, ...state } = s;
  return state;
};
